import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Describe your vision',
  description: "Type a simple description of what you need. Be as vague or specific as you want. 'A mobile banking app dashboard with dark mode'."
}, {
  number: '02',
  title: 'AI Generates Options',
  description: 'Our engine creates 4 distinct variations based on your prompt, adhering to modern UI/UX best practices automatically.'
}, {
  number: '03',
  title: 'Refine & Export',
  description: "Click to edit text, swap components, or regenerate sections. When you're happy, export to your favorite tool."
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-32 px-6 bg-[#0a0a0a] relative overflow-hidden" data-id="element-82">
      {/* Decorative line */}
      <div className="absolute left-1/2 top-0 bottom-0 w-px bg-[#222] -translate-x-1/2 hidden md:block" data-id="element-83" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-84">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-85">
          <h2 className="text-4xl md:text-6xl font-bold mb-4" data-id="element-86">How it works</h2>
          <p className="text-[#a3a3a3]" data-id="element-87">
            From thought to finished design in three steps.
          </p>
        </motion.div>

        <div className="space-y-24 md:space-y-32" data-id="element-88">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7
        }} className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-12 md:gap-24`} data-id="element-89">
              {/* Number Display */}
              <div className="flex-1 flex justify-center md:justify-end" data-id="element-90">
                <div className="relative" data-id="element-91">
                  <span className="text-9xl md:text-[12rem] font-bold text-[#111] font-['Syne'] leading-none select-none" data-id="element-92">
                    {step.number}
                  </span>
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full text-center" data-id="element-93">
                    {/* Abstract visual for each step could go here */}
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 text-center md:text-left" data-id="element-94">
                <h3 className="text-3xl font-bold mb-4 text-[#ff6b35]" data-id="element-95">
                  {step.title}
                </h3>
                <p className="text-xl text-[#a3a3a3] leading-relaxed max-w-md mx-auto md:mx-0" data-id="element-96">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}